// import React, { useState, useEffect } from 'react';
// import Navbar1 from './Navbar';
// import Footer1 from './Footer';
// import { db } from '../../firebaseConfig'; // Import your Firebase configuration
// import { ref, get } from 'firebase/database';
// // import { getAuth } from "firebase/auth";
// import { getAuth, onAuthStateChanged } from "firebase/auth";
// import { getDatabase } from "firebase/database";
// import { useNavigate } from 'react-router-dom';

// const Setting1 = () => {
//   const [activeTab, setActiveTab] = useState('company');
//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
// const navigate = useNavigate();

// // useEffect(() => {
// //   const auth = getAuth();
// //   const unsubscribe = onAuthStateChanged(auth, async (user) => {
// //     if (user) {
// //       const emailKey = user.email.replace(/\./g, "_");
// //       const dbRef = ref(getDatabase(), `Agent/${emailKey}`);
// //       const snapshot = await get(dbRef);
// //       if (snapshot.exists()) {
// //         setUserData(snapshot.val());
// //       } else {
// //         setError("User data not found in DB");
// //       }
// //     } else {
// //       navigate("/agent-connect"); // Redirect to login
// //     }
// //   });

// //   return () => unsubscribe();
// // }, []);

//   // useEffect(() => {
//   //   const auth = getAuth();
//   //   const unsubscribe = onAuthStateChanged(auth, async (user) => {
//   //     try {
//   //       if (!user) {
//   //         navigate("/agent-connect");
//   //         return;
//   //       }

//   //       // Convert email to Firebase key format
//   //       const emailKey = user.email.replace(/\./g, "_");
//   //       const dbRef = ref(db, `Agent/${emailKey}`);

//   //       const snapshot = await get(dbRef);

//   //       if (!snapshot.exists()) {
//   //         throw new Error("User data not found in database");
//   //       }

//   //       setUserData(snapshot.val());
//   //     } catch (err) {
//   //       console.error("Error fetching user data:", err);
//   //       setError(err.message);
//   //     } finally {
//   //       setLoading(false);
//   //     }
//   //   });

//   //   return () => unsubscribe();
//   // }, [navigate]);

//   useEffect(() => {
//     const auth = getAuth();
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       try {
//         if (!user) {
//           navigate("/agent-connect");
//           return;
//         }

//         // Try to get data from localStorage first
//         const cachedData = localStorage.getItem("agent");
//         if (cachedData) {
//           setUserData(JSON.parse(cachedData));
//           setLoading(false);
//           return;
//         }

//         // Convert email to Firebase key format
//         const emailKey = user.email.replace(/\./g, "_");
//         const dbRef = ref(db, `Agent/${emailKey}`);

//         const snapshot = await get(dbRef);

//         if (!snapshot.exists()) {
//           throw new Error("User data not found in database");
//         }

//         const userData = snapshot.val();
//         setUserData(userData);
//         localStorage.setItem("agent", JSON.stringify(userData));
//       } catch (err) {
//         console.error("Error fetching user data:", err);
//         setError(err.message);
//       } finally {
//         setLoading(false);
//       }
//     });

//     return () => unsubscribe();
//   }, [navigate]);

//   const styles = {
//     pageWrapper: {
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       backgroundColor: '#eaeaea',
//       minHeight: '100vh',
//       padding: '100px',
//     },
//     container: {
//       width: '1200px',
//       height: '800px',
//       backgroundColor: '#fff',
//       borderRadius: '8px',
//       boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
//       overflow: 'hidden',
//     },
//     header: {
//       background: 'linear-gradient(to right, #3f51b5, #9c27b0)',
//       color: 'white',
//       padding: '20px',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//     },
//     userInfo: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '15px',
//     },
//     profilePic: {
//       width: '100px',
//       height: '100px',
//       borderRadius: '50%',
//       backgroundColor: '#ccc',
//       justifyContent: 'center',
//     },
//     tabs: {
//       display: 'flex',
//       borderBottom: '1px solid #ddd',
//       backgroundColor: '#fff',
//     },
//     tab: {
//       padding: '12px 20px',
//       cursor: 'pointer',
//       fontSize: '14px',
//       position: 'relative',
//     },
//     activeTab: {
//       fontWeight: 'bold',
//       borderBottom: '2px solid blue',
//     },
//     arrow: {
//       position: 'absolute',
//       bottom: -10,
//       left: '50%',
//       transform: 'translateX(-50%)',
//       width: 0,
//       height: 0,
//       borderLeft: '10px solid transparent',
//       borderRight: '10px solid transparent',
//       borderTop: '10px solid blue',
//     },
//     section: {
//       display: 'flex',
//       flexDirection: 'row',
//     },
//     profileLeft: {
//       width: '380px',
//       height: '640px',
//       backgroundColor: 'red',
//       color: '#fff',
//       textAlign: 'center',
//       padding: '50px',
//     },
//     contentRight: {
//       flex: 1,
//       padding: '20px',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//     },
//     td: {
//       border: '1px solid #ccc',
//       padding: '10px',
//       fontSize: '16px',
//     },
//   };

//   if (loading) return <div style={styles.pageWrapper}><div style={styles.container}>Loading...</div></div>;
//   if (error) return <div style={styles.pageWrapper}><div style={styles.container}>Error: {error}</div></div>;
//   if (!userData) return <div style={styles.pageWrapper}><div style={styles.container}>No data found</div></div>;

//   return (
//     <>
//       <Navbar1 />
//       <div style={styles.pageWrapper}>
//         <div style={styles.container}>
//           {/* Header */}
//           <div style={styles.header}>
//             <div style={styles.userInfo}>
//               <div style={styles.profilePic}></div>
//               <div>
//                 <strong>{userData.firstName?.toUpperCase()} {userData.lastName?.toUpperCase()}</strong><br />
//                 <small>AT {userData.companyName?.toUpperCase() || 'PEARL TOURS AND TRAVELS SANGLI'}</small>
//               </div>
//             </div>
//             <div>JOIN SINCE : {userData.createdAt}</div>
//           </div>

//           {/* Tabs */}
//           <div style={styles.tabs}>
//             {['company', 'user'].map((tabKey) => (
//               <div
//                 key={tabKey}
//                 style={{
//                   ...styles.tab,
//                   ...(activeTab === tabKey ? styles.activeTab : {}),
//                 }}
//                 onClick={() => setActiveTab(tabKey)}
//               >
//                 {tabKey === 'company' ? 'Company Settings' : 'User Management'}
//                 {activeTab === tabKey && <div style={styles.arrow}></div>}
//               </div>
//             ))}
//           </div>

//           {/* Section Content */}
//           <div style={styles.section}>
//             <div style={styles.profileLeft}>
//               <div style={styles.profilePic}></div>
//               <p><strong>{userData.firstName?.toUpperCase()} {userData.lastName?.toUpperCase()}</strong></p>
//               <p style={{ fontSize: '12px' }}>{userData.companyName?.toUpperCase() || 'PEARL TOURS AND TRAVELS SANGLI'}</p>
//             </div>

//             <div style={styles.contentRight}>
//               {activeTab === 'company' ? (
//                 <table style={styles.table}>
//                   <tbody>
//                     <tr>
//                       <td style={styles.td}><strong>Company Name</strong></td>
//                       <td style={styles.td}>{userData.companyName || 'PEARL TOURS AND TRAVELS SANGLI'}</td>
//                     </tr>
//                     <tr>
//                       <td style={styles.td}><strong>Address</strong></td>
//                       <td style={styles.td}>{userData.address || 'SHOP NO 6, PEARL ENCLAVE, MSRB ROAD, VISHRAMBAG, SANGLI'}</td>
//                     </tr>
//                     <tr>
//                       <td style={styles.td}><strong>Country</strong></td>
//                       <td style={styles.td}>{userData.country || 'India'}</td>
//                     </tr>
//                     <tr>
//                       <td style={styles.td}><strong>State</strong></td>
//                       <td style={styles.td}>{userData.state || 'Maharashtra'}</td>
//                     </tr>
//                     <tr>
//                       <td style={styles.td}><strong>City</strong></td>
//                       <td style={styles.td}>{userData.city || 'Sangli'}</td>
//                     </tr>
//                     <tr>
//                       <td style={styles.td}><strong>Zip</strong></td>
//                       <td style={styles.td}>{userData.zipCode || '416416'}</td>
//                     </tr>
//                     <tr>
//                       <td style={styles.td}><strong>PAN Card Name</strong></td>
//                       <td style={styles.td}>{userData.panName || 'ELIYAS ASLAM MAGDUM'}</td>
//                     </tr>
//                     <tr>
//                       <td style={styles.td}><strong>PAN Card Number</strong></td>
//                       <td style={styles.td}>{userData.panNumber || 'AOSPM5894C'}</td>
//                     </tr>
//                   </tbody>
//                 </table>
//               ) : (
//                 <div>
//                   <p>Manage users, permissions, and roles here.</p>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer1 />
//     </>
//   );
// };

// export default Setting1;

import React, { useState, useEffect } from "react";
import Navbar1 from "./Navbar";
import Footer1 from "./Footer";
import { getDatabase, ref, get, set } from "firebase/database";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { FaEdit } from "react-icons/fa";

const Setting1 = () => {
  const [activeTab, setActiveTab] = useState("company");
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [formData, setFormData] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      try {
        if (!user) {
          navigate("/agent-connect");
          return;
        }

        // Try to get data from localStorage first
        const cachedData = localStorage.getItem("agent");
        if (cachedData) {
          const parsedData = JSON.parse(cachedData);
          setUserData(parsedData);
          setFormData(parsedData);
          setLoading(false);
          return;
        }

        // Convert email to Firebase key format
        const emailKey = user.email.replace(/\./g, "_");
        const db = getDatabase();
        const dbRef = ref(db, `Agent/${emailKey}`);

        const snapshot = await get(dbRef);

        if (!snapshot.exists()) {
          throw new Error("User data not found in database");
        }

        const userData = snapshot.val();
        setUserData(userData);
        setFormData(userData);
        localStorage.setItem("agent", JSON.stringify(userData));
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const auth = getAuth();
      const user = auth.currentUser;

      if (!user) {
        navigate("/agent-connect");
        return;
      }

      const emailKey = user.email.replace(/\./g, "_");
      const db = getDatabase();
      const dbRef = ref(db, `Agent/${emailKey}`);

      await set(dbRef, formData);

      // Update local storage
      localStorage.setItem("agent", JSON.stringify(formData));
      setUserData(formData);
      setEditMode(false);
    } catch (err) {
      console.error("Error updating profile:", err);
      setError("Failed to update profile. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Unknown";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const styles = {
    pageWrapper: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: "#eaeaea",
      minHeight: "100vh",
      padding: "20px",
    },
    container: {
      width: "100%",
      maxWidth: "1200px",
      backgroundColor: "#fff",
      borderRadius: "8px",
      boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
      overflow: "hidden",
      margin: "20px 0",
    },
    header: {
      background: "linear-gradient(to right, #3f51b5, #9c27b0)",
      color: "white",
      padding: "20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    userInfo: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
    },
    profilePic: {
      width: "100px",
      height: "100px",
      borderRadius: "50%",
      backgroundColor: "#ccc",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      color: "#fff",
      fontSize: "40px",
      fontWeight: "bold",
    },
    tabs: {
      display: "flex",
      borderBottom: "1px solid #ddd",
      backgroundColor: "#fff",
    },
    tab: {
      padding: "12px 20px",
      cursor: "pointer",
      fontSize: "14px",
      position: "relative",
    },
    activeTab: {
      fontWeight: "bold",
      borderBottom: "2px solid blue",
    },
    arrow: {
      position: "absolute",
      bottom: -10,
      left: "7%",
      transform: "translateX(-50%)",
      width: 0,
      height: 0,
      borderLeft: "10px solid transparent",
      borderRight: "10px solid transparent",
      borderTop: "10px solid blue",
    },
    section: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
    },
    profileLeft: {
      width: "100%",
      maxWidth: "380px",
      backgroundColor: "#c1212a",
      color: "#fff",
      textAlign: "start",
      padding: "30px",
    },
    contentRight: {
      flex: 1,
      padding: "20px",
      minWidth: "300px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
    },
    td: {
      border: "1px solid #ccc",
      padding: "12px",
      fontSize: "16px",
    },
    editButton: {
      position: "absolute",
      top: "330px",
      right: "180px",
      background: "#3f51b5",
      color: "white",
      border: "none",
      borderRadius: "50%",
      width: "40px",
      height: "40px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
      boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
    },
    actionButtons: {
      display: "flex",
      justifyContent: "flex-end",
      gap: "10px",
      marginTop: "20px",
    },
    saveButton: {
      padding: "10px 20px",
      background: "#4CAF50",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
    cancelButton: {
      padding: "10px 20px",
      background: "#f44336",
      color: "white",
      border: "none",
      borderRadius: "4px",
      cursor: "pointer",
    },
    inputField: {
      width: "100%",
      padding: "8px",
      border: "1px solid #ddd",
      borderRadius: "4px",
    },
  };

  if (loading)
    return (
      <div style={styles.pageWrapper}>
        <div style={styles.container}>Loading...</div>
      </div>
    );
  if (error)
    return (
      <div style={styles.pageWrapper}>
        <div style={styles.container}>Error: {error}</div>
      </div>
    );
  if (!userData)
    return (
      <div style={styles.pageWrapper}>
        <div style={styles.container}>No data found</div>
      </div>
    );

  return (
    <>
      <Navbar1 />
      <div style={styles.pageWrapper}>
        <div style={styles.container}>
          {/* Header */}
          <div style={styles.header}>
            <div style={styles.userInfo}>
              <div style={styles.profilePic}>
                {userData.firstName?.charAt(0)}
                {userData.lastName?.charAt(0)}
              </div>
              <div>
                <strong>
                  {userData.firstName?.toUpperCase()}{" "}
                  {userData.lastName?.toUpperCase()}
                </strong>
                <br />
                <small>
                  AT {userData.companyName?.toUpperCase() || "YOUR COMPANY"}
                </small>
              </div>
            </div>
            <div>JOINED: {formatDate(userData.createdAt)}</div>
          </div>

          {/* Tabs */}
          {/* <div style={styles.tabs}>
            {["company", "user"].map((tabKey) => (
             <div style={{ ...styles.tab, ...styles.activeTab }}>
  Company Settings
  <div style={styles.arrow}></div>
</div>

            ))}
          </div> */}



<div style={{ ...styles.tab, ...styles.activeTab }}>
  Company Settings
  <div style={styles.arrow}></div>
</div>


          {/* Section Content */}
          <div style={styles.section}>
            <div style={styles.profileLeft}>
              <div style={styles.profilePic}>
                {userData.firstName?.charAt(0)}
                {userData.lastName?.charAt(0)}
              </div>
              <p>
                <strong>
                  {userData.firstName?.toUpperCase()}{" "}
                  {userData.lastName?.toUpperCase()}
                </strong>
              </p>
              <p style={{ fontSize: "12px" }}>
                {userData.companyName?.toUpperCase() || "YOUR COMPANY"}
              </p>
            </div>

            <div style={styles.contentRight}>
              {!editMode && (
                <button
                  style={styles.editButton}
                  onClick={() => setEditMode(true)}
                  title="Edit Profile"
                >
                  <FaEdit />
                </button>
              )}

              {activeTab === "company" ? (
                <table style={styles.table}>
                  <tbody>
                    <tr>
                      <td style={styles.td}>
                        <strong>Company Name</strong>
                      </td>
                      <td style={styles.td}>
                        {editMode ? (
                          <input
                            type="text"
                            name="companyName"
                            value={formData.companyName || ""}
                            onChange={handleInputChange}
                            style={styles.inputField}
                          />
                        ) : (
                          userData.companyName || "Not provided"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.td}>
                        <strong>Mobile</strong>
                      </td>
                      <td style={styles.td}>
                        {editMode ? (
                          <input
                            type="tel"
                            name="mobile"
                            value={formData.mobile || ""}
                            onChange={handleInputChange}
                            style={styles.inputField}
                          />
                        ) : (
                          userData.mobile || "Not provided"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.td}>
                        <strong>Email</strong>
                      </td>
                      <td style={styles.td}>
                        {userData.email || "Not provided"}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.td}>
                        <strong>Address</strong>
                      </td>
                      <td style={styles.td}>
                        {editMode ? (
                          <input
                            type="text"
                            name="address"
                            value={formData.address || ""}
                            onChange={handleInputChange}
                            style={styles.inputField}
                          />
                        ) : (
                          userData.address || "Not provided"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.td}>
                        <strong>Country</strong>
                      </td>
                      <td style={styles.td}>
                        {editMode ? (
                          <input
                            type="text"
                            name="country"
                            value={formData.country || ""}
                            onChange={handleInputChange}
                            style={styles.inputField}
                          />
                        ) : (
                          userData.country || "Not provided"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.td}>
                        <strong>State</strong>
                      </td>
                      <td style={styles.td}>
                        {editMode ? (
                          <input
                            type="text"
                            name="state"
                            value={formData.state || ""}
                            onChange={handleInputChange}
                            style={styles.inputField}
                          />
                        ) : (
                          userData.state || "Not provided"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.td}>
                        <strong>City</strong>
                      </td>
                      <td style={styles.td}>
                        {editMode ? (
                          <input
                            type="text"
                            name="city"
                            value={formData.city || ""}
                            onChange={handleInputChange}
                            style={styles.inputField}
                          />
                        ) : (
                          userData.city || "Not provided"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.td}>
                        <strong>Pin Code</strong>
                      </td>
                      <td style={styles.td}>
                        {editMode ? (
                          <input
                            type="text"
                            name="pinCode"
                            value={formData.pinCode || ""}
                            onChange={handleInputChange}
                            style={styles.inputField}
                          />
                        ) : (
                          userData.pinCode || "Not provided"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.td}>
                        <strong>PAN Card Name</strong>
                      </td>
                      <td style={styles.td}>
                        {editMode ? (
                          <input
                            type="text"
                            name="panName"
                            value={formData.panName || ""}
                            onChange={handleInputChange}
                            style={styles.inputField}
                          />
                        ) : (
                          userData.panName || "Not provided"
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td style={styles.td}>
                        <strong>PAN Card Number</strong>
                      </td>
                      <td style={styles.td}>
                        {editMode ? (
                          <input
                            type="text"
                            name="panNumber"
                            value={formData.panNumber || ""}
                            onChange={handleInputChange}
                            style={styles.inputField}
                          />
                        ) : (
                          userData.panNumber || "Not provided"
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <div>
                  <p>Manage users, permissions, and roles here.</p>
                </div>
              )}

              {editMode && (
                <div style={styles.actionButtons}>
                  <button
                    style={styles.saveButton}
                    onClick={handleSave}
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save Changes"}
                  </button>
                  <button
                    style={styles.cancelButton}
                    onClick={() => {
                      setEditMode(false);
                      setFormData(userData);
                    }}
                    disabled={loading}
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer1 />
    </>
  );
};

export default Setting1;
